import { render, staticRenderFns } from "./BulkReviewForm.vue?vue&type=template&id=e2445c10"
import script from "./BulkReviewForm.vue?vue&type=script&lang=js"
export * from "./BulkReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports